export default "__VITE_ASSET__9bc167fc__"